var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Section",
    _vm._b(
      {
        attrs: {
          title: _vm.title,
          shouldShowSearch: _vm.shouldShowSearch,
          toolbarActions: _vm.toolbarActions,
          isPrimary: _vm.isPrimary,
          icon: "event",
          isLoading: _vm.isLoading,
        },
        on: { onClicked: (val) => _vm.$emit(val) },
      },
      "Section",
      _vm.$attrs,
      false
    ),
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.activityList,
          "item-key": "id",
          "rows-per-page-items": [15, 25, 50, 100],
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.activityTypeList,
                          idKey: "id",
                          idValue: props.item.typeId,
                          propertyKey: "name",
                        })
                      ) +
                      "\n        " +
                      _vm._s(
                        _vm._formatJavascriptDate({
                          date: props.item.dateTimePerformedOn,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.assetStatusList,
                          idKey: "id",
                          idValue: props.item.statusId,
                          propertyKey: "name",
                          emptyText: "N/A",
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.locationList,
                          idKey: "id",
                          idValue: props.item.locationId,
                          propertyKey: "name",
                          emptyText: "N/A",
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._entityPropertyValueByName({
                          entityList: _vm.userList,
                          idKey: "id",
                          idValue: props.item.userIdPerformedBy,
                          propertyKey: "name",
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    props.item.attachmentList &&
                    props.item.attachmentList.length
                      ? _vm._l(
                          props.item.attachmentList,
                          function (attachment) {
                            return _c("div", { key: attachment.id }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(attachment.fileName) +
                                  "\n          "
                              ),
                            ])
                          }
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-right" },
                  [
                    _c("ControlButton", {
                      attrs: {
                        text: "View",
                        depressed: "",
                        disabled: _vm.isLoading,
                      },
                      on: {
                        onClicked: function ($event) {
                          return _vm.$emit("onClickViewActivity", {
                            activityId: props.item.id,
                          })
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }